/**
 * @generated SignedSource<<a57c988e36a91632ded7d32bf4cea848>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "_id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "stateList"
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTime",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTime",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "age",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyServiceFee",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "platformFeePercentage",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dailyFee",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expectedTotalFee",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expectedStartTime",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expectedEndTime",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expectedServiceHours",
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expectedServiceDays",
        "storageKey": null
    }, v17 = [
        (v3 /*: any*/),
        (v4 /*: any*/),
        (v10 /*: any*/),
        (v11 /*: any*/),
        (v12 /*: any*/),
        (v13 /*: any*/),
        (v14 /*: any*/),
        (v15 /*: any*/),
        (v16 /*: any*/)
    ], v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v19 = [
        (v18 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "district",
            "storageKey": null
        }
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "c_at",
        "storageKey": null
    }, v21 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "_id",
                    "variableName": "_id"
                },
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "stateList",
                    "variableName": "stateList"
                }
            ],
            "concreteType": "ClientCareOrder",
            "kind": "LinkedField",
            "name": "clientCareOrderList",
            "plural": true,
            "selections": [
                (v3 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "initialType",
                    "storageKey": null
                },
                (v4 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "certificateId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefaultAsap",
                    "storageKey": null
                },
                (v5 /*: any*/),
                (v6 /*: any*/),
                (v7 /*: any*/),
                (v8 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredGender",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hospitalBed",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servedItem",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "symptom",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tube",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lang",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notes",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactGender",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactPhone",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactEmail",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalPaidFee",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "doPayOffPayment",
                    "storageKey": null
                },
                (v9 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notesParsed",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "c_atParsed",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTimeSlot",
                    "kind": "LinkedField",
                    "name": "defaultTimeSlotList",
                    "plural": true,
                    "selections": (v17 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTimeSlot",
                    "kind": "LinkedField",
                    "name": "timeSlotList",
                    "plural": true,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v10 /*: any*/),
                        (v11 /*: any*/),
                        (v12 /*: any*/),
                        (v13 /*: any*/),
                        (v14 /*: any*/),
                        (v15 /*: any*/),
                        (v16 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalServiceFee",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPlatformFee",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalFee",
                            "storageKey": null
                        },
                        (v5 /*: any*/),
                        (v6 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "HospitalId",
                    "kind": "LinkedField",
                    "name": "hospitalObj",
                    "plural": false,
                    "selections": (v19 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientCareTaker",
                    "kind": "LinkedField",
                    "name": "careTaker",
                    "plural": false,
                    "selections": [
                        (v20 /*: any*/),
                        (v18 /*: any*/),
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phone",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientCareTakerMatchedCareOrder",
                            "kind": "LinkedField",
                            "name": "matchedCareOrderList",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isPrimary",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bundleStartTime",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bundleEndTime",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientMakeOffer",
                    "kind": "LinkedField",
                    "name": "makeOfferList",
                    "plural": true,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dailyServiceFee",
                            "storageKey": null
                        },
                        (v9 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "revealedTime",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expectedConcealTime",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLiked",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientUnmatchedCareTaker",
                            "kind": "LinkedField",
                            "name": "careTaker",
                            "plural": false,
                            "selections": [
                                (v20 /*: any*/),
                                (v18 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminQuote",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatarPhotoUrl",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "aboutMeText",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CareTakerFeedbackSummary",
                                    "kind": "LinkedField",
                                    "name": "feedbackSummary",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CareTakerFeedbackRemark",
                                            "kind": "LinkedField",
                                            "name": "remarkList",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "titleZh",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "count",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CareTakerFeedbackComment",
                                            "kind": "LinkedField",
                                            "name": "commentList",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "comment",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "commentedTime",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "HospitalId",
                                                    "kind": "LinkedField",
                                                    "name": "hospital",
                                                    "plural": false,
                                                    "selections": (v19 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "avgScore",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "successCareOrderCount",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientTimeSlot",
                            "kind": "LinkedField",
                            "name": "timeSlotList",
                            "plural": true,
                            "selections": (v17 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "graphqlClientCareOrderListQuery",
            "selections": (v21 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v2 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Operation",
            "name": "graphqlClientCareOrderListQuery",
            "selections": (v21 /*: any*/)
        },
        "params": {
            "cacheID": "023eaa1a786337b2818535ae5d1d5126",
            "id": null,
            "metadata": {},
            "name": "graphqlClientCareOrderListQuery",
            "operationKind": "query",
            "text": "query graphqlClientCareOrderListQuery(\n  $_id: String!\n  $stateList: [Int]\n  $limit: Int\n) {\n  clientCareOrderList(_id: $_id, stateList: $stateList, limit: $limit) {\n    _id\n    initialType\n    state\n    certificateId\n    isDefaultAsap\n    startTime\n    endTime\n    gender\n    age\n    height\n    weight\n    requiredGender\n    hospitalBed\n    servedItem\n    symptom\n    tube\n    lang\n    notes\n    contactName\n    contactGender\n    contactPhone\n    contactEmail\n    totalPaidFee\n    doPayOffPayment\n    hourlyServiceFee\n    notesParsed\n    c_atParsed\n    defaultTimeSlotList {\n      _id\n      state\n      platformFeePercentage\n      dailyFee\n      expectedTotalFee\n      expectedStartTime\n      expectedEndTime\n      expectedServiceHours\n      expectedServiceDays\n    }\n    timeSlotList {\n      _id\n      state\n      platformFeePercentage\n      dailyFee\n      expectedTotalFee\n      expectedStartTime\n      expectedEndTime\n      expectedServiceHours\n      expectedServiceDays\n      totalServiceFee\n      totalPlatformFee\n      totalFee\n      startTime\n      endTime\n    }\n    hospitalObj {\n      name\n      city\n      district\n    }\n    careTaker {\n      c_at\n      name\n      gender\n      age\n      phone\n      matchedCareOrderList {\n        isPrimary\n        bundleStartTime\n        bundleEndTime\n      }\n    }\n    makeOfferList {\n      _id\n      state\n      dailyServiceFee\n      hourlyServiceFee\n      revealedTime\n      expectedConcealTime\n      isLiked\n      careTaker {\n        c_at\n        name\n        gender\n        age\n        adminQuote\n        avatarPhotoUrl\n        aboutMeText\n        feedbackSummary {\n          remarkList {\n            titleZh\n            count\n          }\n          commentList {\n            comment\n            commentedTime\n            hospital {\n              name\n              city\n              district\n            }\n          }\n          avgScore\n          successCareOrderCount\n        }\n      }\n      timeSlotList {\n        _id\n        state\n        platformFeePercentage\n        dailyFee\n        expectedTotalFee\n        expectedStartTime\n        expectedEndTime\n        expectedServiceHours\n        expectedServiceDays\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "5b91444adfc5f01fc5f64328046cb0cb";
export default node;
